export default function CTASection() {
  return (
    <section className="relative w-full py-24 md:py-32 px-6 md:px-10 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20luxurious%20fashion%20retail%20display%20scene%20with%20neatly%20arranged%20premium%20sneakers%20hoodies%20and%20leather%20accessories%20on%20modern%20wooden%20shelves%2C%20soft%20ambient%20lighting%20creating%20gentle%20shadows%2C%20cream%20beige%20and%20warm%20earthy%20tones%2C%20elegant%20boutique%20atmosphere%2C%20editorial%20quality%20product%20photography%2C%20clean%20minimalist%20composition%2C%20no%20blue%20or%20purple%20colors&width=1600&height=700&seq=cta-bg-2026-x02&orientation=landscape"
          alt="Premium fashion products display at CSSBuy Spreadsheet"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-10">
          <div className="max-w-xl">
            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight">
              shop smarter
            </h2>
          </div>

          <div className="max-w-md">
            <p className="text-base md:text-lg text-background-200 leading-relaxed">
              Skip the endless scrolling through unverified seller albums. Our CSSBuy Spreadsheet puts thousands of quality-checked product finds at your fingertips.
            </p>
          </div>

          <div className="flex-shrink-0">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-3 px-8 py-4 bg-background-50 text-foreground-900 rounded-full text-base font-semibold hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer group"
            >
              buy it now
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-900 text-background-50 group-hover:bg-primary-500 transition-colors">
                <i className="ri-arrow-right-line text-lg"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}